/* eslint-disable react/display-name */
import { Popconfirm, Space } from "antd";
import React from "react";
import { Tag } from "antd";

import TableBase from "../../../../../components/table/TableBase";
import { allowPermission, convertHexToRGBA } from "../../../../../helper/util";
import { useSelector } from "react-redux";
import { selectRole } from "modules/auth/store/authSlice";
import { UserRole } from "configs/constants";

const ClientUserTable = ({ dataSource, pagination, onEdit, onDelete }) => {
  const role = useSelector(selectRole);
  const canEdit = allowPermission(role, [UserRole.ADMIN]);
  const canDelete = allowPermission(role, [UserRole.ADMIN]);
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      width: 110,
      render: (value) => {
        return (
          <p style={{ margin: 0, color: "#1f3998" }}>
            {value.substr(0, 8).toUpperCase()}
          </p>
        );
      }
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      width: 120
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      width: 120
    },
    {
      title: "Email",
      dataIndex: "email",
      width: 160,
      ellipsis: true
    },
    {
      title: "Role",
      dataIndex: "role",
      width: 120,
      render: (value) => {
        let text = "Super Admin";
        let color = "#43c1c2";
        switch (value) {
          case "manager":
            text = "Manager";
            color = "#f78B0f";
            break;
          case "viewer":
            text = "View Only";
            color = "#212121";
            break;
          default:
            break;
        }
        return (
          <Tag
            color={convertHexToRGBA(color, 20)}
            style={{
              color,
              lineHeight: "24px",
              width: "112px",
              textAlign: "center",
              fontWeight: "600"
            }}
          >
            {text}
          </Tag>
        );
      }
    },
    {
      title: "Phone Number",
      dataIndex: "phone",
      width: 170
    }
  ];

  if (canEdit || canDelete) {
    columns.push({
      title: "",
      key: "action",
      width: 100,
      fixed: "right",
      // eslint-disable-next-line react/display-name
      render: (value, record) => {
        return (
          <Space size="middle">
            {canEdit && (
              <img
                src="/icons/edit.svg"
                className={`table-status ${value}`}
                onClick={() => onEdit(record)}
              />
            )}
            {canDelete && (
              <Popconfirm
                title="Are you sure to delete this?"
                onConfirm={() => onDelete(record.id)}
                okText="Yes"
                cancelText="No"
              >
                <img src="/icons/delete.svg" className={`table-status ${value}`} />
              </Popconfirm>
            )}
          </Space>
        );
      }
    });
  }

  return (
    <div className="ClientUserTable">
      <TableBase
        columns={columns}
        data={dataSource}
        pagination={pagination}
        rowKey="id"
      />
    </div>
  );
};
export default ClientUserTable;
